// Recent searches for the global search bar, kept only in this browser (localStorage).
// One list per logged-in user, so another admin on the same computer doesn't see it.
// Every result that is opened from the search bar is stored (members, contacts,
// finance, yahrzeit, pages / tabs and Settings pages); the newest is first.

export const MAX_RECENT_SEARCHES = 3;
const MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000; // items older than 90 days are dropped

const storageKey = (userKey) => `recent_searches_${userKey || "anonymous"}`;

// what is needed to show the item again and to open it
const pick = (item) => ({
  type: item?.type,
  _id: item?._id,
  account_id: item?.account_id,
  member_id: item?.member_id,
  name: item?.name,
  url: item?.url,
  section: item?.section,
});

// Settings and page results have no id: they are the same item when they open the same place
const sameItem = (a, b) =>
  a?.type === b?.type && (a?.type === "settings" || a?.type === "page" ? a?.url === b?.url && a?.name === b?.name : a?._id === b?._id);

export const getRecentSearches = (userKey) => {
  try {
    const items = JSON.parse(localStorage.getItem(storageKey(userKey)) || "[]");
    const fresh = Array.isArray(items) ? items.filter((item) => item?.type && Date.now() - (item.searchedAt || 0) < MAX_AGE_MS) : [];
    return fresh.slice(0, MAX_RECENT_SEARCHES);
  } catch (e) {
    return [];
  }
};

export const addRecentSearch = (userKey, item) => {
  if (!item?.type || !item?.name) return getRecentSearches(userKey);
  const entry = { ...pick(item), searchedAt: Date.now() };
  const items = [entry, ...getRecentSearches(userKey).filter((old) => !sameItem(old, entry))].slice(0, MAX_RECENT_SEARCHES);
  try {
    localStorage.setItem(storageKey(userKey), JSON.stringify(items));
  } catch (e) {
    // storage full or blocked: recent searches are a convenience, ignore
  }
  return items;
};

export const clearRecentSearches = (userKey) => {
  try {
    localStorage.removeItem(storageKey(userKey));
  } catch (e) {
    // ignore
  }
  return [];
};
